import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export const logout = async ({ locationId, userId }: { locationId: string; userId: string }) => {
	const query = gql`
		mutation logout($locationId: String!, $userId: String!) {
			logout(locationId: $locationId, userId: $userId) {
				locationId
				userId
			}
		}
	`;

	const variables = {
		locationId,
		userId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.logout;
	} catch (err) {
		errorLogger(err as Error);
		return null;
	}
};
